module.exports = __webpack_public_path__ + "static/media/img_loewy.00567754.jpg";